import {
  Box,
  Stack
} from '@mui/material'
import React, { useMemo, useState } from 'react'
import convertAccounts from 'packages/ui/Arborist/utils'
import Tree from 'packages/ui/Arborist/components/Tree'
import TreeSearch from 'packages/ui/Arborist/components/Search/Search'
import SearchEmptySelection from 'packages/ui/Arborist/components/Search/SearchEmptySelection'
import StackSelection from 'packages/ui/Arborist/components/StackSelection'
import { useTreeContext, useSitesSelected } from 'packages/ui/Arborist/TreeProvider'
import { useInPerimeter } from 'packages/ui/Arborist/utils'
import TopBar from 'packages/ui/Arborist/components/TopBar/TopBar'

const tabTransitionSx = {
  animation: 'masterFilterTabFade 160ms ease-out',
  '@keyframes masterFilterTabFade': {
    from: {
      opacity: 0,
      transform: 'translateY(3px)'
    },
    to: {
      opacity: 1,
      transform: 'translateY(0)'
    }
  }
}

const MasterFilterPopover = ({ accounts, searchVerbatim = '' }) => {
  const [activeTab, setActiveTab] = useState(0)
  const {selection, onNodeRemove, onNodeAdd, waiting, treeRef} = useTreeContext()
  const { sites: sitesSelected } = useSitesSelected({selection})
  const checkedAccounts = useInPerimeter()
  const searchValue = searchVerbatim.trim()
  const tree = useMemo(() => {
    return convertAccounts({ accounts})
  }, [accounts])

  if (activeTab === 1) {
    return (
      <Stack>
        <TopBar
          activeTab={activeTab}
          onTabChange={setActiveTab}
          showSearch
        />
        <Box
          key="selected-sites"
          sx={{
            mt: 2,
            ...tabTransitionSx
          }}>
          {sitesSelected.length === 0 ? (
            <SearchEmptySelection />
          ) : (
            <StackSelection
              onRemoveAccount={(account) => {
                onNodeRemove({ id: account.sf_id })
              }}
              accounts={sitesSelected}
              treeRef={treeRef}
            />
          )}
        </Box>
      </Stack>
    )
  }

  return (
    <Stack>
      <TopBar
        activeTab={activeTab}
        onTabChange={setActiveTab}
        showSearch
      />
      <Box
        key="all-sites"
        sx={{
          position: 'relative',
          mt: 2,
          ...tabTransitionSx
        }}
      >
        {searchValue ? (
          <TreeSearch
            ref={treeRef}
            name={searchVerbatim}
            view={'master-filter'}
            hideTopBar
          />
        ) : (
          <Tree
            ref={treeRef}
            data={tree}
            openByDefault={false}
            padding={2}
            onNodeSelect={async (node) => {
              const checked = checkedAccounts.findIndex(account => account.sf_id === node.data.data.sf_id) > -1
              if (!checked) {
                if (!waiting) {
                  await onNodeAdd(node)
                }
              } else {
                onNodeRemove(node)
              }
            }}
            onParentNodeSelect={() => {}}
          />
        )}
      </Box>
    </Stack>
  )
}

export default MasterFilterPopover
